import { useTheme } from '@emotion/react';
import {
  alpha,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  styled,
  useMediaQuery,
} from '@mui/material';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import FlexRowAlign from 'components/flexbox/FlexRowAlign';
import { H3, H6, TableContent } from 'components/Typography';
import { CircleAlert, Share2Icon, ThumbsDown, ThumbsUp } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const StyledCard = styled(Card)(({ theme, isTablet }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0rem',
  justifyContent: 'space-between',
  flexDirection: 'column',
  border: 'none',
  borderRadius: isTablet ? '0px' : '24px',
  boxShadow: isTablet ? 'none' : '0px 4px 20px rgba(0, 0, 0, 0.08)',
  borderBottom: isTablet ? '1px solid #E1E1E1' : 'none',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

const AIReplyCard = ({
  isLiked,
  onLike,
  isDisliked,
  onDislike,
  reply,
  avatar,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  return (
    <StyledCard isTablet={isTablet}>
      <FlexBox
        flexDirection={'row'}
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        backgroundColor={theme.palette.primary.yellow300}
        sx={{
          padding: isMobile ? '1rem 0rem 0rem 1rem' : '2rem 2rem 2rem 2rem',
        }}
      >
        <Grid
          mb={isMobile ? 2 : 0}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <FlexBox
            alignItems="center"
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate('/naver/community/profile/other')}
          >
            <AppAvatar
              alt="avatar"
              src={avatar}
              style={{
                width: '48px',
                height: '48px',
                padding: '0.4rem',
                backgroundColor: 'white',
              }}
            />
            <FlexBox flexDirection="column" ml={1.5} textAlign="left">
              <H3
                sx={{
                  whiteSpace: 'nowrap',
                  color: theme.palette.primary.white,
                }}
              >
                슈가 AI
              </H3>
            </FlexBox>
          </FlexBox>
        </Grid>
      </FlexBox>

      <FlexBox
        pt={4}
        mb={3}
        px={isMobile ? 2 : 4}
        flexDirection={'column'}
        gap={3}
      >
        <FlexBox
          flexDirection={'row'}
          justifyContent="space-between"
          alignItems="flex-start"
          width="100%"
        >
          <Chip
            icon={
              <CircleAlert
                size={16}
                style={{ marginLeft: '8px' }}
                color={theme.palette.primary.orange}
              />
            }
            label={'AI 답변이므로, 참조만 부탁드립니다'}
            sx={{
              height: 22,
              fontSize: 14,
              borderRadius: 1,
              color: theme.palette.primary.orange, // Orange color
              backgroundColor: alpha('#EF9123', 0.15),
            }}
          />
        </FlexBox>
        <H6 sx={{ textAlign: 'left', width: '100%' }}>
          {reply.split('\n').map((item, key) => (
            <React.Fragment key={key}>
              {item}
              <br />
            </React.Fragment>
          ))}
        </H6>
      </FlexBox>

      <Divider
        style={{
          height: '1px',
          margin: isMobile ? '0px 0rem' : '0px -2rem',
          backgroundColor: '#E1E1E1',
          width: 'calc(100% + 4rem)',
        }}
      />

      <FlexRowAlign
        px={isMobile ? 2 : 4}
        my={3}
        justifyContent="space-between"
        width="100%"
      >
        <FlexRowAlign gap={1}>
          <TableContent>추천 답변이 마음에 드셨나요?</TableContent>
          <Button
            variant="outlined"
            size="small"
            onClick={onLike}
            sx={{
              minWidth: 'fit-content',
              paddingX: 1,
              color: isLiked ? theme.palette.primary.mainBlue : '#636469',
              borderColor: isLiked ? theme.palette.primary.mainBlue : 'none',
            }}
          >
            <ThumbsUp
              color={isLiked ? theme.palette.primary.mainBlue : '#636469'}
              size={20}
            />
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={onDislike}
            sx={{
              minWidth: 'fit-content',
              paddingX: 1,
              color: isDisliked ? theme.palette.primary.mainBlue : '#636469',
              borderColor: isDisliked ? theme.palette.primary.mainBlue : 'none',
            }}
          >
            <ThumbsDown
              color={isDisliked ? theme.palette.primary.mainBlue : '#636469'}
              size={20}
            />
          </Button>
        </FlexRowAlign>

        <Button
          variant="outlined"
          size="small"
          sx={{
            // ...ButtonStyle,
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: 'fit-content',
          }}
        >
          <FlexRowAlign component="span" gap={1}>
            <Share2Icon size={18} sx={{ marginRight: '4px' }} />
            {!isMobile && '공유'}
          </FlexRowAlign>
        </Button>
      </FlexRowAlign>
    </StyledCard>
  );
};

export default AIReplyCard;
